module.exports = __webpack_public_path__ + "img/club-ruy-logo.e7b6a100.svg";